export interface FeatureHintDef {
  id: string
  tab: string // which activeTab triggers this hint
  title: string
  description: string
  icon: 'sparkles' | 'lightbulb' | 'zap' | 'info'
  position: 'top' | 'bottom' | 'top-right' | 'top-left'
  variant: 'tooltip' | 'banner' // banner = full-width bar at top of content
  isNew?: boolean // shows 'Nuevo' badge
  addedDate?: string // ISO date
  delay?: number // ms before showing (default 1000)
  autoDismiss?: number // ms before auto-hide (default 8000)
}
const hints: FeatureHintDef[] = [
  {
    id: 'dashboard-widgets',
    tab: 'dashboard',
    title: 'Dashboard personalizable',
    description:
      'Agregá y organizá widgets desde el catálogo para armar tu vista ideal.',
    icon: 'sparkles',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'chat-commands',
    tab: 'chat',
    title: 'Comandos rápidos',
    description:
      'Escribí / en el chat para ver comandos disponibles y cambiar de modo.',
    icon: 'zap',
    position: 'bottom',
    variant: 'banner',
  },
  {
    id: 'connectors-plugins',
    tab: 'connectors',
    title: 'Plugins por conector',
    description:
      'Hacé click en ⚡ para activar plugins que extienden cada integración.',
    icon: 'zap',
    position: 'top',
    variant: 'banner',
    isNew: true,
  },
  {
    id: 'sprint-detail',
    tab: 'sprint',
    title: 'Detalle de issues',
    description:
      'Hacé click en cualquier issue para ver su detalle completo y acciones.',
    icon: 'lightbulb',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'kanban-drag',
    tab: 'kanban',
    title: 'Arrastrá y soltá',
    description:
      'Mové tarjetas entre columnas para cambiar el estado de los issues.',
    icon: 'lightbulb',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'docs-summarize',
    tab: 'docs',
    title: 'Resúmenes con IA',
    description:
      'Usá el botón Resumir para generar un resumen automático de cualquier página.',
    icon: 'sparkles',
    position: 'top',
    variant: 'banner',
    isNew: true,
  },
  {
    id: 'backlog-filters',
    tab: 'backlog',
    title: 'Filtrá tu backlog',
    description:
      'Usá los filtros para ordenar por prioridad, tipo o story points.',
    icon: 'lightbulb',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'settings-admin',
    tab: 'settings',
    title: 'Modo Admin',
    description:
      'Desbloqueá el modo Admin para ver y editar credenciales de integraciones.',
    icon: 'info',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'github-panel',
    tab: 'github',
    title: 'GitHub integrado',
    description:
      'Revisá PRs, commits y CI/CD directamente sin salir de la app.',
    icon: 'zap',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'agents-marketplace',
    tab: 'agents',
    title: 'Marketplace de Agentes',
    description: 'Explorá y contratá agentes IA especializados para tu equipo.',
    icon: 'sparkles',
    position: 'top',
    variant: 'banner',
    isNew: true,
  },
  {
    id: 'billing-plans',
    tab: 'billing',
    title: 'Planes y uso',
    description:
      'Compará planes, monitoreá tu consumo y gestioná tu suscripción.',
    icon: 'info',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'slack-messages',
    tab: 'slack',
    title: 'Slack en tiempo real',
    description:
      'Mensajes y notificaciones de tus canales sincronizados automáticamente.',
    icon: 'zap',
    position: 'top',
    variant: 'banner',
  },
  {
    id: 'health-check',
    tab: 'health',
    title: 'Diagnóstico de Conexiones',
    description:
      'Monitoreá la latencia y el estado de todas tus integraciones en tiempo real.',
    icon: 'info',
    position: 'top',
    variant: 'banner',
    isNew: true,
  },
]
const STORAGE_KEY = 'feature-hints-seen'
function getSeenHints(): string[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : []
  } catch (e) {
    return []
  }
}
export function getHintForTab(tab: string): FeatureHintDef | null {
  const seen = getSeenHints()
  return hints.find((h) => h.tab === tab && !seen.includes(h.id)) || null
}
export function getAllHints(): FeatureHintDef[] {
  return hints
}
export function markHintSeen(id: string): void {
  try {
    const seen = getSeenHints()
    if (!seen.includes(id)) {
      seen.push(id)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(seen))
    }
  } catch (e) {}
}
export function isHintSeen(id: string): boolean {
  return getSeenHints().includes(id)
}
export function resetAllHints(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {}
}
